<template>
  <div class="hm-part2-contact">
    <p>微信客服：kehigh001</p>
    <p>客服电话：17796327580</p>
    <p>官方网站：<a href="https://www.kehigh.com">www.kehigh.com</a></p>
    <p>商务邮箱：business@kehigh.com</p>
    <p>关注公众号：微信搜“可瀚学堂”和“可瀚戏剧表演”</p>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {}
};
</script>

<style scoped lang="scss">
@import "../../src/assets/css/basic";
.hm-part2-contact {
  padding: p2r(39) p2r(30) p2r(26);
  font-size: p2r(16);
  line-height: p2r(38);
  box-shadow: 0px p2r(6) p2r(10) 0px rgba(36, 188, 255, 0.35);
  border-radius: p2r(16);
  position: relative;
  &::after{
    content: '';
    position: absolute;
    width: 100%;
    height: p2r(34);
    background-color: #2ed6ff;
    top: 0;
    left: 0;
    border-radius: p2r(16) p2r(16) 0 0;
  }

  a {
    color: $blue;
    text-decoration: underline;
  }
}
</style>
